<div class="header-wrapper" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="modal-icon font-size-16 w-20 h-20 red-500-bg fuse-white-fg">close</mat-icon>
    <span class="modal-header font-size-18 text-bold red-500-fg">{{ 'DIALOG.CANCEL_APPROVED_REQUEST.HEADER' | translate }}</span>
</div>
<div mat-dialog-content class="p-0 font-weight-400 mat-body-1 mt-20 mb-24" [innerHTML]="'DIALOG.CANCEL_APPROVED_REQUEST.MESSAGE' | translate : { name: data.code }">
    {{ 'DIALOG.CANCEL_APPROVED_REQUEST.MESSAGE' | translate : { name: data.code } }}
</div>
<div class="dialog-content mt-24 mx-0 w-100-p">
    <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>{{ 'DIALOG.CANCEL_APPROVED_REQUEST.PLACEHOLDER' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="reason" class="h-116" required></textarea>
    </mat-form-field>
</div>
<div class="w-100-p text-center">
    <button [disabled]="!reason || (reason && reason.length < 1)" mat-raised-button (click)="dialogRef.close(reason)" class="artstuff-btn w-120 mr-16"
        [ngClass]="{ 'red-500-bg fuse-white-fg': reason && reason.length > 0, grey: !reason || (reason && reason.length < 1) }">
        {{ 'DIALOG.CANCEL_APPROVED_REQUEST.ACCEPT_BUTTON_TEXT' | translate }}
    </button>
    <button mat-button class="w-120 artstuff-btn" (click)="dialogRef.close(false)">
        {{ 'DIALOG.CANCEL_APPROVED_REQUEST.CANCEL_BUTTON_TEXT' | translate }}
    </button>
</div>